import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { DialogConfirm } from 'components'
import { cloneDeep } from 'lodash'
import { FormControl, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material'

import { formatToCNPJ, formatToCPF } from 'brazilian-values'
import { createComplianceListRecord, updateComplianceListRecord } from "../../../../services/apiKYP"
import { OPERATION_MESSAGES } from "../../../../utils/constants/operations"

const initialState = {
  cpf_cnpj: '',
  flag_denylist: true,
  flag_attention: false,
}

const initialErrors = {
  cpf_cnpj: false,
}

function ComplianceForm(props) {
  const { compliance_list, handleClose, open } = props

  const token = useSelector((state) => state.auth.access_token)

  const isEditMode = compliance_list !== undefined && compliance_list !== null
  const [formState, setFormState] = useState(initialState)
  const [formErrors, setFormErrors] = useState(initialErrors)

  const [documentType, setDocumentType] = useState('cpf')

  const handleCPFCNPJChange = (event) => {
    const key = event.target.id
    const newFormState = cloneDeep(formState)
    newFormState[key] = documentType
      ? formatToCPF(event.target.value)
      : formatToCNPJ(event.target.value)
    setFormState(newFormState)
  }

  const handleDocumentTypeChange = (event) => {
    const newFormState = cloneDeep(formState)
    newFormState.cpf_cnpj = ''
    setFormState(newFormState)
    setDocumentType(event.target.value)
  }

  const handleListTypeChange = (event) => {
    const newFormState = cloneDeep(formState)
    if (event.target.value === 'deny_list') {
      newFormState.flag_denylist = true
      newFormState.flag_attention = false
    } else {
      newFormState.flag_denylist = false
      newFormState.flag_attention = true
    }
    setFormState(newFormState)
  }

  const clearAndClose = () => {
    setFormState(initialState)
    setFormErrors(initialErrors)
    setDocumentType('cpf')
    handleClose()
  }

  const validate = () => {
    const errors = cloneDeep(initialErrors)

    Object.keys(errors).forEach((key) => {
      if (formState[key] === '') errors[key] = true
    })

    if (Object.keys(errors).some((key) => errors[key])) {
      setFormErrors(errors)
      return false
    }

    return true
  }

  const handleSubmit = () => {
    const data = cloneDeep(formState)

    if (!validate()) {
      toast.error(OPERATION_MESSAGES.CHECK_INFORMED_DATA)
      return
    }

    if (isEditMode) {
      updateComplianceListRecord(
        token, data,
      ).then((response) => {
        if (response.status === 204) {
          toast.success(OPERATION_MESSAGES.RECORD_UPDATE_SUCCESS)
          clearAndClose()
        }
      })
        .catch(() => {
          toast.error(OPERATION_MESSAGES.RECORD_UPDATE_FAIL)
        })
        .finally(() => {

        })
    } else {
      createComplianceListRecord(token, data)
        .then((response) => {
          if (response.status === 201) {
            toast.success(OPERATION_MESSAGES.RECORD_ADD_SUCCESS)
            clearAndClose()
          }
        })
        .catch(() => {
          toast.error(OPERATION_MESSAGES.RECORD_ADD_FAIL)
        })
    }
  }

  useEffect(() => {
    if (compliance_list) {
      setFormState(compliance_list)
    } else {
      setFormState(initialState)
    }
  }, [compliance_list])

  return (
    <DialogConfirm
      open={open}
      title="Compliance List"
      onConfirm={handleSubmit}
      onCancel={handleClose}
      btnCancelText="Cancelar"
      contextText='Informe abaixo, os dados de compliance. '
      showCloseButton={true}
      fullWidth={true}
    >
      <React.Fragment>
        <FormControl>
          <RadioGroup
            row
            value={documentType}
            name="document-type"
            onChange={handleDocumentTypeChange}
          >
            <FormControlLabel disabled={isEditMode} value="cpf" control={<Radio />} label="CPF" />
            <FormControlLabel disabled={isEditMode} value="cnpj" control={<Radio />} label="CNPJ" />
          </RadioGroup>
        </FormControl>

        <TextField
          id="cpf_cnpj"
          label={documentType.toUpperCase()}
          onChange={handleCPFCNPJChange}
          value={formState.cpf_cnpj}
          error={formErrors.cpf_cnpj}
          size="small"
          fullWidth
          disabled={isEditMode}
          margin="dense"
          autoFocus
          variant="standard"
          required
        />

        <FormControl>
          <RadioGroup
            row
            value={formState.flag_denylist ? 'deny_list' : 'attention_list'}
            name="document-type"
            onChange={handleListTypeChange}
          >
            <FormControlLabel
              value="deny_list"
              control={<Radio />}
              label="Deny List"
            />
            <FormControlLabel
              value="attention_list"
              control={<Radio />}
              label="Attention List"
            />
          </RadioGroup>
        </FormControl>
      </React.Fragment>
    </DialogConfirm>
  )
}

export default ComplianceForm
